import * as i0 from '@angular/core';
import { EventEmitter, Component, ChangeDetectionStrategy, ViewEncapsulation, Input, Output, NgModule } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1 from '@niceltd/sol/translation';
import * as i3 from '@niceltd/sol/text-input';
import { TextInputModule } from '@niceltd/sol/text-input';
import * as i4 from '@niceltd/sol/button';
import { ButtonModule } from '@niceltd/sol/button';
import * as i5 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import * as i6 from '@niceltd/sol/tooltip';
import { TooltipModule } from '@niceltd/sol/tooltip';
function OmnibarComponent_div_5_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("trigger", "mouseenter focus")("overflowTooltip", true)("interactive", true)("content", ctx_r4.itemCountLabel)("arrow", true);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r4.itemCountLabel, " ");
  }
}
function OmnibarComponent_div_5_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 15);
  }
}
function OmnibarComponent_div_5_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("trigger", "mouseenter focus")("overflowTooltip", true)("interactive", true)("content", ctx_r6.selectedItemCountLabel)("arrow", true);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r6.selectedItemCountLabel, " ");
  }
}
function OmnibarComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, OmnibarComponent_div_5_div_1_Template, 2, 6, "div", 11)(2, OmnibarComponent_div_5_div_2_Template, 1, 0, "div", 12)(3, OmnibarComponent_div_5_div_3_Template, 2, 6, "div", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.itemCountLabel !== undefined);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.selectedItemCountLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.selectedItemCountLabel);
  }
}
function OmnibarComponent_div_6_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 21);
    i0.ɵɵelement(1, "path", 22);
    i0.ɵɵelementEnd();
  }
}
function OmnibarComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtemplate(1, OmnibarComponent_div_6_ng_template_1_Template, 2, 0, "ng-template", null, 18, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(3, "div", 19)(4, "sol-text-input", 20);
    i0.ɵɵtwoWayListener("ngModelChange", function OmnibarComponent_div_6_Template_sol_text_input_ngModelChange_4_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r9 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r9.searchQuery, $event) || (ctx_r9.searchQuery = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("valueChange", function OmnibarComponent_div_6_Template_sol_text_input_valueChange_4_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r11 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r11.searchQueryChange.emit(ctx_r11.searchQuery));
    })("keydown.enter", function OmnibarComponent_div_6_Template_sol_text_input_keydown_enter_4_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r12 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r12.onSearchBtnClick());
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const _r8 = i0.ɵɵreference(2);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("type", "search")("leadingIcon", _r8)("placeholderText", ctx_r1.searchPlaceholderText);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.searchQuery);
    i0.ɵɵproperty("aria-label", "search");
  }
}
function OmnibarComponent_div_7_ng_template_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 30);
  }
}
function OmnibarComponent_div_7_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵtemplate(1, OmnibarComponent_div_7_ng_template_1_Conditional_1_Template, 1, 0, "span", 27);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 28);
    i0.ɵɵelement(3, "path", 29);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(1, ctx_r13.filtersSelected ? 1 : -1);
  }
}
function OmnibarComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵtemplate(1, OmnibarComponent_div_7_ng_template_1_Template, 4, 1, "ng-template", null, 24, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(3, "sol-button", 25);
    i0.ɵɵlistener("onClick", function OmnibarComponent_div_7_Template_sol_button_onClick_3_listener() {
      i0.ɵɵrestoreView(_r17);
      const ctx_r16 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r16.toggleFiltersSection());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const _r14 = i0.ɵɵreference(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("iconPositionedFront", _r14)("variant", "basic")("size", "large")("ariaLabel", "toggle filter");
  }
}
function OmnibarComponent_section_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "section", 31)(1, "div", 32);
    i0.ɵɵprojection(2, 1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 33);
    i0.ɵɵprojection(4, 2);
    i0.ɵɵelementEnd()();
  }
}
const _c0 = [[["sol-omnibar-custom-content"]], [["sol-omnibar-filters"]], [["sol-omnibar-tags"]]];
const _c1 = ["sol-omnibar-custom-content", "sol-omnibar-filters", "sol-omnibar-tags"];
const _c2 = ["*"];
let omnibarCount = 1;
class OmnibarComponent {
  set id(id) {
    this._id = id;
  }
  get id() {
    if (!this._id) {
      return `sol-omnibar-${this._uniqueId}`;
    }
    return this._id;
  }
  constructor(translationService) {
    this.translationService = translationService;
    this._id = '';
    /* Determines if the complete header section of the omnibar is to be content projected or not */
    this.customOmnibar = false;
    /* Determines whether to show the filter button or not */
    this.isFilterable = true;
    /* The label to show the total count of an entity */
    this.itemCountLabel = '';
    /* Determines whether to show a search input field or not */
    this.searchable = true;
    /* The search query */
    this.searchQuery = '';
    /* The search field placeholder text */
    this.searchPlaceholderText = '';
    /* Determines wehther the omnibar footer is to be shown or not */
    this.showFooter = false;
    this.filtersSelected = false;
    /* A callback to indicate that the search query has changed in the text field */
    this.searchQueryChange = new EventEmitter();
    /* A callback to indicate that the search icon has been clicked */
    this.searchButtonClicked = new EventEmitter();
    /* A callback to indicate that the search icon has been clicked */
    this.showFooterChanged = new EventEmitter();
    this._uniqueId = omnibarCount++;
  }
  onSearchBtnClick() {
    if (this.searchQuery) this.searchButtonClicked.emit(this.searchQuery);
  }
  toggleFiltersSection() {
    this.showFooter = !this.showFooter;
    this.showFooterChanged.emit(this.showFooter);
  }
  static {
    this.ɵfac = function OmnibarComponent_Factory(t) {
      return new (t || OmnibarComponent)(i0.ɵɵdirectiveInject(i1.TranslationService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: OmnibarComponent,
      selectors: [["sol-omnibar"]],
      inputs: {
        id: "id",
        customOmnibar: "customOmnibar",
        isFilterable: "isFilterable",
        itemCountLabel: "itemCountLabel",
        searchable: "searchable",
        searchQuery: "searchQuery",
        searchPlaceholderText: "searchPlaceholderText",
        selectedItemCountLabel: "selectedItemCountLabel",
        showFooter: "showFooter",
        filtersSelected: "filtersSelected"
      },
      outputs: {
        searchQueryChange: "searchQueryChange",
        searchButtonClicked: "searchButtonClicked",
        showFooterChanged: "showFooterChanged"
      },
      ngContentSelectors: _c1,
      decls: 11,
      vars: 5,
      consts: [[1, "sol-omnibar", 3, "id"], [1, "content-wrapper", "flex-container", "column"], [1, "header-wrapper", "flex-container"], [1, "count-wrapper", "flex-container"], [1, "count-search-wrapper"], ["class", "count-container", 4, "ngIf"], ["class", "search-wrapper", 4, "ngIf"], ["class", "filter-wrapper", 4, "ngIf"], [1, "custom-content-wrapper"], ["class", "footer-wrapper", 4, "ngIf"], [1, "count-container"], ["class", "count-label", "aria-live", "assertive", "solTooltip", "", 3, "trigger", "overflowTooltip", "interactive", "content", "arrow", 4, "ngIf"], ["class", "vertical-line", 4, "ngIf"], ["class", "selected-count", "solTooltip", "", 3, "trigger", "overflowTooltip", "interactive", "content", "arrow", 4, "ngIf"], ["aria-live", "assertive", "solTooltip", "", 1, "count-label", 3, "trigger", "overflowTooltip", "interactive", "content", "arrow"], [1, "vertical-line"], ["solTooltip", "", 1, "selected-count", 3, "trigger", "overflowTooltip", "interactive", "content", "arrow"], [1, "search-wrapper"], ["searchIcon", ""], [1, "search-box"], [3, "type", "leadingIcon", "placeholderText", "ngModel", "aria-label", "ngModelChange", "valueChange", "keydown.enter"], ["width", "16", "height", "16", "viewBox", "0 0 16 16", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M0 6.4C0 9.92 2.88 12.8 6.4 12.8C7.84 12.8 9.2 12.32 10.32 11.44L14.64 15.76C14.96 16.08 15.44 16.08 15.76 15.76C16.08 15.44 16.08 14.96 15.76 14.64L11.44 10.32C12.32 9.2 12.8 7.84 12.8 6.4C12.8 2.88 9.92 0 6.4 0C2.88 0 0 2.88 0 6.4ZM1.6 6.4C1.6 3.76 3.76 1.6 6.4 1.6C9.04 1.6 11.2 3.76 11.2 6.4C11.2 9.04 9.04 11.2 6.4 11.2C3.76 11.2 1.6 9.04 1.6 6.4Z", "fill", "#3F5C69"], [1, "filter-wrapper"], ["filterIcon", ""], [3, "iconPositionedFront", "variant", "size", "ariaLabel", "onClick"], [1, "filter-icon"], ["class", "notify-badge"], ["width", "20", "height", "20", "viewBox", "0 0 20 20", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M16.7465 2L10.9681 9.3V16.2L8.97549 17.3V9.3L8.57698 8.8L3.19708 2H16.7465ZM19.1375 0H0.806006C0.507123 0 0.208239 0.2 0.108611 0.5C-0.0906444 0.8 0.00898344 1.2 0.208239 1.4L6.98294 10V19C6.98294 19.3 7.28182 19.7 7.5807 19.9C7.68033 20 7.87959 20 7.97921 20C8.07884 20 8.17847 20 8.37773 19.9L12.3628 17.8C12.6617 17.7 13.0602 17.4 13.0602 17V10L19.8349 1.4C20.0342 1.1 20.0342 0.8 19.9346 0.5C19.7353 0.2 19.4364 0 19.1375 0V0Z", "fill", "#003D7A"], [1, "notify-badge"], [1, "footer-wrapper"], [1, "dropdown-wrapper"], [1, "tags-wrapper"]],
      template: function OmnibarComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c0);
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "section", 2)(3, "div", 3)(4, "div", 4);
          i0.ɵɵtemplate(5, OmnibarComponent_div_5_Template, 4, 3, "div", 5)(6, OmnibarComponent_div_6_Template, 5, 5, "div", 6);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(7, OmnibarComponent_div_7_Template, 4, 4, "div", 7);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(8, "div", 8);
          i0.ɵɵprojection(9);
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(10, OmnibarComponent_section_10_Template, 5, 0, "section", 9);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("id", ctx.id);
          i0.ɵɵadvance(5);
          i0.ɵɵproperty("ngIf", ctx.itemCountLabel && !ctx.customOmnibar);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.searchable && !ctx.customOmnibar);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.isFilterable);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.isFilterable && ctx.showFooter);
        }
      },
      dependencies: [i2.NgIf, i3.TextInputComponent, i4.ButtonComponent, i5.NgControlStatus, i5.NgModel, i6.TooltipDirective],
      styles: [".sol-omnibar{background-color:#f9fafb}.sol-omnibar .flex-container{display:flex;align-items:center}.sol-omnibar .flex-container.column{flex-direction:column}.sol-omnibar .content-wrapper{width:100%;padding:0;margin:0;gap:.25rem}.sol-omnibar .content-wrapper .header-wrapper{width:100%;padding:.75rem;box-sizing:border-box;display:flex}.sol-omnibar .content-wrapper .header-wrapper .count-wrapper{color:var(--color-interface-text700);font-family:var(--typography-opensans-headline-body-font-family);font-style:var(--typography-opensans-headline-h5-font-style);font-weight:var(--typography-opensans-headline-body-font-weight);font-size:var(--typography-opensans-headline-body-font-size);line-height:var(--typography-opensans-headline-body-line-height);text-decoration:var(--typography-opensans-headline-h5-text-decoration);letter-spacing:var(--typography-opensans-headline-h5-letter-spacing);text-transform:var(--typography-opensans-headline-h5-text-case);display:flex;flex-wrap:nowrap;gap:.5rem}.sol-omnibar .content-wrapper .header-wrapper .count-wrapper .count-search-wrapper{display:flex;gap:1.25rem}.sol-omnibar .content-wrapper .header-wrapper .count-wrapper .count-container{width:100%;display:flex;gap:.75rem;align-items:center}.sol-omnibar .content-wrapper .header-wrapper .count-wrapper .count-container .vertical-line{width:.063rem;height:1.25rem;background-color:#0003}.sol-omnibar .content-wrapper .header-wrapper .count-wrapper .count-container .selected-count,.sol-omnibar .content-wrapper .header-wrapper .count-wrapper .count-container .count-label{text-wrap:nowrap;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;max-width:18.75rem}.sol-omnibar .content-wrapper .header-wrapper .search-wrapper{width:100%;display:flex;justify-content:center;align-items:center;gap:.5rem}.sol-omnibar .content-wrapper .header-wrapper .search-wrapper .search-box{width:100%;display:flex;justify-content:center;align-items:center;max-width:22.5rem;min-width:20rem}.sol-omnibar .content-wrapper .header-wrapper .search-wrapper .search-box>:first-child{width:100%;height:2.25rem}.sol-omnibar .content-wrapper .header-wrapper .filter-wrapper{float:right;margin:0 .5rem 0 0}.sol-omnibar .content-wrapper .header-wrapper .filter-wrapper .filter-icon{position:relative;display:inline-block}.sol-omnibar .content-wrapper .header-wrapper .filter-wrapper .filter-icon svg{margin-top:3px}.sol-omnibar .content-wrapper .header-wrapper .filter-wrapper .filter-icon .notify-badge{width:.64rem;height:.625rem;position:absolute;right:-.125rem;top:-.125rem;background:var(--background-status-info-regular);border-radius:.938rem;color:#fff}.sol-omnibar .content-wrapper .header-wrapper .custom-content-wrapper{display:flex;position:relative;flex:1;margin:0 .5rem 0 0;justify-content:flex-end}.sol-omnibar .content-wrapper .header-wrapper .custom-content-wrapper>:first-child{display:inline-flex;gap:.5rem}.sol-omnibar .content-wrapper .footer-wrapper{width:100%;padding:0 .75rem .5rem;display:grid;align-items:flex-end;box-sizing:border-box}.sol-omnibar .content-wrapper .footer-wrapper>:not(:empty){display:grid}.sol-omnibar .content-wrapper .footer-wrapper>:empty{display:none}.sol-omnibar .content-wrapper .footer-wrapper .tags-wrapper{padding:.5rem 0}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OmnibarComponent, [{
    type: Component,
    args: [{
      selector: 'sol-omnibar',
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      template: "<div class=\"sol-omnibar\" [id]=\"id\">\n  <div class=\"content-wrapper flex-container column\">\n    <section class=\"header-wrapper flex-container\">\n      <div class=\"count-wrapper flex-container\">\n        <div class=\"count-search-wrapper\">\n          <div class=\"count-container\" *ngIf=\"itemCountLabel && !customOmnibar\">\n            <div\n              class=\"count-label\"\n              *ngIf=\"itemCountLabel !== undefined\"\n              aria-live=\"assertive\"\n              solTooltip\n              [trigger]=\"'mouseenter focus'\"\n              [overflowTooltip]=\"true\"\n              [interactive]=\"true\"\n              [content]=\"itemCountLabel\"\n              [arrow]=\"true\"\n            >\n              {{ itemCountLabel }}\n            </div>\n            <div class=\"vertical-line\" *ngIf=\"selectedItemCountLabel\"></div>\n            <div\n              class=\"selected-count\"\n              *ngIf=\"selectedItemCountLabel\"\n              solTooltip\n              [trigger]=\"'mouseenter focus'\"\n              [overflowTooltip]=\"true\"\n              [interactive]=\"true\"\n              [content]=\"selectedItemCountLabel\"\n              [arrow]=\"true\"\n            >\n              {{ selectedItemCountLabel }}\n            </div>\n          </div>\n          <div class=\"search-wrapper\" *ngIf=\"searchable && !customOmnibar\">\n            <ng-template #searchIcon>\n              <svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                <path\n                  d=\"M0 6.4C0 9.92 2.88 12.8 6.4 12.8C7.84 12.8 9.2 12.32 10.32 11.44L14.64 15.76C14.96 16.08 15.44 16.08 15.76 15.76C16.08 15.44 16.08 14.96 15.76 14.64L11.44 10.32C12.32 9.2 12.8 7.84 12.8 6.4C12.8 2.88 9.92 0 6.4 0C2.88 0 0 2.88 0 6.4ZM1.6 6.4C1.6 3.76 3.76 1.6 6.4 1.6C9.04 1.6 11.2 3.76 11.2 6.4C11.2 9.04 9.04 11.2 6.4 11.2C3.76 11.2 1.6 9.04 1.6 6.4Z\"\n                  fill=\"#3F5C69\"\n                />\n              </svg>\n            </ng-template>\n            <div class=\"search-box\">\n              <sol-text-input\n                [type]=\"'search'\"\n                [leadingIcon]=\"searchIcon\"\n                [placeholderText]=\"searchPlaceholderText\"\n                [(ngModel)]=\"searchQuery\"\n                (valueChange)=\"searchQueryChange.emit(searchQuery)\"\n                [aria-label]=\"'search'\"\n                (keydown.enter)=\"onSearchBtnClick()\"\n              >\n              </sol-text-input>\n            </div>\n          </div>\n        </div>\n        <div class=\"filter-wrapper\" *ngIf=\"isFilterable\">\n          <ng-template #filterIcon>\n            <div class=\"filter-icon\">\n              @if (filtersSelected) {\n                <span class=\"notify-badge\"></span>\n              }\n              <svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                <path\n                  d=\"M16.7465 2L10.9681 9.3V16.2L8.97549 17.3V9.3L8.57698 8.8L3.19708 2H16.7465ZM19.1375 0H0.806006C0.507123 0 0.208239 0.2 0.108611 0.5C-0.0906444 0.8 0.00898344 1.2 0.208239 1.4L6.98294 10V19C6.98294 19.3 7.28182 19.7 7.5807 19.9C7.68033 20 7.87959 20 7.97921 20C8.07884 20 8.17847 20 8.37773 19.9L12.3628 17.8C12.6617 17.7 13.0602 17.4 13.0602 17V10L19.8349 1.4C20.0342 1.1 20.0342 0.8 19.9346 0.5C19.7353 0.2 19.4364 0 19.1375 0V0Z\"\n                  fill=\"#003D7A\"\n                />\n              </svg>\n            </div>\n          </ng-template>\n          <sol-button\n            [iconPositionedFront]=\"filterIcon\"\n            [variant]=\"'basic'\"\n            [size]=\"'large'\"\n            [ariaLabel]=\"'toggle filter'\"\n            (onClick)=\"toggleFiltersSection()\"\n          >\n          </sol-button>\n        </div>\n      </div>\n\n      <div class=\"custom-content-wrapper\">\n        <ng-content select=\"sol-omnibar-custom-content\"></ng-content>\n      </div>\n    </section>\n    <section class=\"footer-wrapper\" *ngIf=\"isFilterable && showFooter\">\n      <div class=\"dropdown-wrapper\">\n        <ng-content select=\"sol-omnibar-filters\"></ng-content>\n      </div>\n      <div class=\"tags-wrapper\">\n        <ng-content select=\"sol-omnibar-tags\"></ng-content>\n      </div>\n    </section>\n  </div>\n</div>\n",
      styles: [".sol-omnibar{background-color:#f9fafb}.sol-omnibar .flex-container{display:flex;align-items:center}.sol-omnibar .flex-container.column{flex-direction:column}.sol-omnibar .content-wrapper{width:100%;padding:0;margin:0;gap:.25rem}.sol-omnibar .content-wrapper .header-wrapper{width:100%;padding:.75rem;box-sizing:border-box;display:flex}.sol-omnibar .content-wrapper .header-wrapper .count-wrapper{color:var(--color-interface-text700);font-family:var(--typography-opensans-headline-body-font-family);font-style:var(--typography-opensans-headline-h5-font-style);font-weight:var(--typography-opensans-headline-body-font-weight);font-size:var(--typography-opensans-headline-body-font-size);line-height:var(--typography-opensans-headline-body-line-height);text-decoration:var(--typography-opensans-headline-h5-text-decoration);letter-spacing:var(--typography-opensans-headline-h5-letter-spacing);text-transform:var(--typography-opensans-headline-h5-text-case);display:flex;flex-wrap:nowrap;gap:.5rem}.sol-omnibar .content-wrapper .header-wrapper .count-wrapper .count-search-wrapper{display:flex;gap:1.25rem}.sol-omnibar .content-wrapper .header-wrapper .count-wrapper .count-container{width:100%;display:flex;gap:.75rem;align-items:center}.sol-omnibar .content-wrapper .header-wrapper .count-wrapper .count-container .vertical-line{width:.063rem;height:1.25rem;background-color:#0003}.sol-omnibar .content-wrapper .header-wrapper .count-wrapper .count-container .selected-count,.sol-omnibar .content-wrapper .header-wrapper .count-wrapper .count-container .count-label{text-wrap:nowrap;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;max-width:18.75rem}.sol-omnibar .content-wrapper .header-wrapper .search-wrapper{width:100%;display:flex;justify-content:center;align-items:center;gap:.5rem}.sol-omnibar .content-wrapper .header-wrapper .search-wrapper .search-box{width:100%;display:flex;justify-content:center;align-items:center;max-width:22.5rem;min-width:20rem}.sol-omnibar .content-wrapper .header-wrapper .search-wrapper .search-box>:first-child{width:100%;height:2.25rem}.sol-omnibar .content-wrapper .header-wrapper .filter-wrapper{float:right;margin:0 .5rem 0 0}.sol-omnibar .content-wrapper .header-wrapper .filter-wrapper .filter-icon{position:relative;display:inline-block}.sol-omnibar .content-wrapper .header-wrapper .filter-wrapper .filter-icon svg{margin-top:3px}.sol-omnibar .content-wrapper .header-wrapper .filter-wrapper .filter-icon .notify-badge{width:.64rem;height:.625rem;position:absolute;right:-.125rem;top:-.125rem;background:var(--background-status-info-regular);border-radius:.938rem;color:#fff}.sol-omnibar .content-wrapper .header-wrapper .custom-content-wrapper{display:flex;position:relative;flex:1;margin:0 .5rem 0 0;justify-content:flex-end}.sol-omnibar .content-wrapper .header-wrapper .custom-content-wrapper>:first-child{display:inline-flex;gap:.5rem}.sol-omnibar .content-wrapper .footer-wrapper{width:100%;padding:0 .75rem .5rem;display:grid;align-items:flex-end;box-sizing:border-box}.sol-omnibar .content-wrapper .footer-wrapper>:not(:empty){display:grid}.sol-omnibar .content-wrapper .footer-wrapper>:empty{display:none}.sol-omnibar .content-wrapper .footer-wrapper .tags-wrapper{padding:.5rem 0}\n"]
    }]
  }], () => [{
    type: i1.TranslationService
  }], {
    id: [{
      type: Input
    }],
    customOmnibar: [{
      type: Input
    }],
    isFilterable: [{
      type: Input
    }],
    itemCountLabel: [{
      type: Input
    }],
    searchable: [{
      type: Input
    }],
    searchQuery: [{
      type: Input
    }],
    searchPlaceholderText: [{
      type: Input
    }],
    selectedItemCountLabel: [{
      type: Input
    }],
    showFooter: [{
      type: Input
    }],
    filtersSelected: [{
      type: Input
    }],
    searchQueryChange: [{
      type: Output
    }],
    searchButtonClicked: [{
      type: Output
    }],
    showFooterChanged: [{
      type: Output
    }]
  });
})();
class OmnibarFiltersComponent {
  static {
    this.ɵfac = function OmnibarFiltersComponent_Factory(t) {
      return new (t || OmnibarFiltersComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: OmnibarFiltersComponent,
      selectors: [["sol-omnibar-filters"]],
      ngContentSelectors: _c2,
      decls: 1,
      vars: 0,
      template: function OmnibarFiltersComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OmnibarFiltersComponent, [{
    type: Component,
    args: [{
      selector: 'sol-omnibar-filters',
      template: '<ng-content></ng-content>'
    }]
  }], null, null);
})();
class OmnibarCustomContentComponent {
  static {
    this.ɵfac = function OmnibarCustomContentComponent_Factory(t) {
      return new (t || OmnibarCustomContentComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: OmnibarCustomContentComponent,
      selectors: [["sol-omnibar-custom-content"]],
      ngContentSelectors: _c2,
      decls: 1,
      vars: 0,
      template: function OmnibarCustomContentComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OmnibarCustomContentComponent, [{
    type: Component,
    args: [{
      selector: 'sol-omnibar-custom-content',
      template: '<ng-content></ng-content>'
    }]
  }], null, null);
})();
class OmnibarTagsComponent {
  static {
    this.ɵfac = function OmnibarTagsComponent_Factory(t) {
      return new (t || OmnibarTagsComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: OmnibarTagsComponent,
      selectors: [["sol-omnibar-tags"]],
      ngContentSelectors: _c2,
      decls: 1,
      vars: 0,
      template: function OmnibarTagsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OmnibarTagsComponent, [{
    type: Component,
    args: [{
      selector: 'sol-omnibar-tags',
      template: '<ng-content></ng-content>'
    }]
  }], null, null);
})();
class OmnibarModule {
  static {
    this.ɵfac = function OmnibarModule_Factory(t) {
      return new (t || OmnibarModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: OmnibarModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, TextInputModule, ButtonModule, FormsModule.withConfig({
        callSetDisabledState: 'whenDisabledForLegacyCode'
      }), TooltipModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OmnibarModule, [{
    type: NgModule,
    args: [{
      declarations: [OmnibarComponent, OmnibarFiltersComponent, OmnibarCustomContentComponent, OmnibarTagsComponent],
      imports: [CommonModule, TextInputModule, ButtonModule, FormsModule.withConfig({
        callSetDisabledState: 'whenDisabledForLegacyCode'
      }), TooltipModule],
      exports: [OmnibarComponent, OmnibarCustomContentComponent, OmnibarFiltersComponent, OmnibarTagsComponent]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { OmnibarComponent, OmnibarCustomContentComponent, OmnibarFiltersComponent, OmnibarModule, OmnibarTagsComponent };
